/* eslint-disable max-len */
/* eslint-disable no-undef */
import {
    ActivationCodesRepository,
    PaymentTypesRepository,
    AppIntegrationsRepository,
    MeRepository,
    TransactionsRepository,
    LicensesRepository,
    AppPricesRepository,
} from 'common/repositories/index';

import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import log from 'common/services/logging/loggers';
import eventManager from 'common/services/-RFC.eventManager';

angular.module('controllers').controller(
    'PaymentCart',
    (
        $scope, $stateParams, $state, $window, $location,
        Util, ActivationCodeRestService, PaymentUrlsRestService, PaymentTypesRestService,
        TransactionRestService, LicenseRestService, $rootScope,
    ) => {

        $scope.showLoading = true;
        const userCountry = MeRepository.getMyUser().attributes.country;

        const {
            subsource,
            promotion,
            runtime,
            variant,
            trial,
            test,
            button,
        } = $stateParams;

        const appId = $state.current.name.indexOf('.device-details') > -1 ? $stateParams.appId : $stateParams.resourceId;
        $rootScope.dwmPurchaseEventSend = false;
        $rootScope.primePurchaseEventSend = false;

        // CMA Links
        const currentLanguage = CWCONFIG.language;
        $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
        $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
        $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
        $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
        $scope.cancellation = `${CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage)}" target="_blank"`;
        // End CMA links

        // Get app data for the success modal
        $scope.app = AppIntegrationsRepository.getById(appId);
        $scope.brandName = CWCONFIG.partnerConfig.name;
        const isBusinessProduct =
            CWCONFIG.store.businessProducts.find(product => product === appId);

        const mixpanelDetails = {
            Page: Util.getPageName(),
            Source: subsource,
            Modal: 'Cart Iframe',
            Product: trial ? 'Prime 60 Days Trial' : $scope.app.attributes.name,
            'Product ID': $scope.app.id,
            Region: 'CB',
            'License Merged': false,
        };

        const sortActivationCodeAfterRuntime = (nextActivationCode, currentActivationCode) => {

            if (
                Util.getRemainingRuntime(nextActivationCode) <
                Util.getRemainingRuntime(currentActivationCode)
            ) {

                return 1;

            } else if (
                Util.getRemainingRuntime(nextActivationCode) >
                Util.getRemainingRuntime(currentActivationCode)
            ) {

                return -1;

            }

            return 0;

        };


        const getLicenseIdForMerge = () => {

            const appComponents = Util.deepFind($scope.app, 'relationships.apps') || {};

            let availableLicensesForMerge = [];
            angular.copy(ActivationCodesRepository.getAll(), availableLicensesForMerge);

            // if it is not Prime we accept only apps that is found in its app components
            if (!(appId === 'aps10' || appId === 'aps20')) {

                let appComponentsIntergration = [];
                if (appComponents.data) {

                    appComponentsIntergration = appComponents.data.map(app => AppIntegrationsRepository.getById(app.id));

                }

                availableLicensesForMerge = availableLicensesForMerge.filter((activationCode) => {

                    const activationCodeIntegration =
                        AppIntegrationsRepository.getById(activationCode.attributes.app);

                    const commonLicense = appComponentsIntergration.find(app =>
                        Util.compareString(Util.deepFind(app, 'attributes.resource.oeName'), Util.deepFind(activationCodeIntegration, 'attributes.resource.oeName'))
                        || Util.compareString(Util.deepFind(app, 'attributes.name'), Util.deepFind(activationCodeIntegration, 'attributes.name'))
                        || Util.compareString(Util.deepFind(app, 'attributes.prototype'), Util.deepFind(activationCodeIntegration, 'attributes.prototype')));

                    return !!(commonLicense);

                });

            }

            let sortedAvailableLicensesForMerge = [];
            if (availableLicensesForMerge.length > 0) {

                // sort the array after runtime
                sortedAvailableLicensesForMerge =
                availableLicensesForMerge.sort(sortActivationCodeAfterRuntime);

                // remove stand-alone licenses if there is any available bundle for merge
                const availableBundleForMerge =
                    sortedAvailableLicensesForMerge.filter((activationCode) => {

                        const appIntegration =
                            AppIntegrationsRepository.getById(activationCode.attributes.app);
                        const bundleType = Util.deepFind(appIntegration, 'attributes.type');
                        const includedApps = Util.deepFind(appIntegration, 'relationships.apps.data');

                        return bundleType === 'bundle' && includedApps.length > 1;

                    });

                // choose bundle with the highest priority (based on its order in the CWCONFIG array)
                if (availableBundleForMerge.length > 0) {

                    const bundleIds = CWCONFIG.devices.bundles;
                    let index = 0;
                    let chosenBundleForMerge;
                    const availableBundleId = availableBundleForMerge.map(activationCode => activationCode.attributes.app);
                    while (index < bundleIds.length && !chosenBundleForMerge) {

                        const commonIdIndex = availableBundleId.indexOf(bundleIds[index]);
                        if (commonIdIndex === -1) {

                            index += 1;

                        } else {

                            chosenBundleForMerge = availableBundleForMerge[commonIdIndex];

                        }

                    }

                    sortedAvailableLicensesForMerge = chosenBundleForMerge ? [chosenBundleForMerge] : availableBundleForMerge;

                }

            }

            if (sortedAvailableLicensesForMerge.length > 0) {

                const license = LicensesRepository.getLicenseBy(sortedAvailableLicensesForMerge[0].id);
                return license && license.id;

            }

            return undefined;

        };

        let { licenseId } = $stateParams;
        licenseId = licenseId || getLicenseIdForMerge();

        const onMergingLicense = licenseId ? LicensesRepository.getLicenseById(licenseId) : {};

        const navigator = Util.getDeviceNavigator();

        const processPaymentUrlResponse = (response) => {

            let shopUrl = Util.deepFind(response.data.data[0], 'attributes.url');

            if (trial === 'true') {

                shopUrl = `${$rootScope.primeTrialShopUrl}&x-a-source=cw&x-a-license_type=trial-store`;

            }

            /*  Add x-a-content param in purchase url if exists.
                The parameter is used in Cleverbridge to filter purchases
                when we are doing A/B tests in dashboard */
            if (variant) {

                shopUrl = `${Util.deepFind(response.data.data[0], 'attributes.url')}&x-a-content=${variant}`;

            }

            const ssoExtraParams = sessionStorage.getItem('SsoExtraUrlParams');

            if (ssoExtraParams && ssoExtraParams.indexOf('cw_lp_paid_search') > -1) {

                shopUrl = `${shopUrl}&x-a-campaign=cw_lp_paid_search`;

            }

            if (!$stateParams.licenseId && getLicenseIdForMerge()) {

                shopUrl = `${shopUrl}&x-operation=upgrade`;

            }

            if (test) {

                shopUrl = `${shopUrl}&x-a-aiatest=${test}`;

            }

            if (button) {

                shopUrl = `${shopUrl}&x-a-button=${button}`;

            }

            $scope.shopUrl = shopUrl;

            // open new tab for business products - All regions
            if (isBusinessProduct) {

                if (userCountry === 'US' || userCountry === 'CA') {

                    mixpanelDetails.Region = 'CA';

                }

                Mixpanel.send('ConnectWeb Modal Open', mixpanelDetails);

                if (navigator === 'ios') {

                    $window.location.href = $scope.shopUrl;

                } else {

                    $window.open($scope.shopUrl, '_blank');

                }
                $scope.closeModal();

            } else if (userCountry === 'US' || userCountry === 'CA') {

                // open new tab for consumer products - CA region (US and CA only)
                mixpanelDetails.Region = 'CA';
                Mixpanel.send('ConnectWeb Modal Open', mixpanelDetails);

                if (navigator === 'ios') {

                    $window.location.href = $scope.shopUrl;
                    $scope.closeModal();

                }

                $scope.showCartIframe = true;

            } else {

                // show iframe for consumer products - CB region (rest of the world)
                $scope.showCartIframe = true;

            }

        };

        const processPaymentUrlError = (error, callMethod) => {

            // Error reporting
            log.error(error);
            ErrorHandler.reportEvent('Cart Iframe Payment', { method: callMethod, error });

            // Fallback in case something went wrong and the url is not available
            let eshopUrl = CWCONFIG.store.fallbackShopUrl;
            eshopUrl = eshopUrl.replace('{language}', CWCONFIG.language);

            if (navigator === 'ios') {

                $window.location.href = `${eshopUrl}&x-a-content=${subsource}-${appId}`;

            } else {

                $window.open(`${eshopUrl}&x-a-content=${subsource}-${appId}`, '_blank');

            }

        };

        // Get Payment Urls
        if (runtime && !licenseId) {

            PaymentUrlsRestService.getByAppIdAndRuntime(appId, runtime, subsource)
                .then((response) => {

                    processPaymentUrlResponse(response);

                })
                .catch((err) => {

                    processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdAndRuntime');

                });

        } else if (runtime && licenseId) {

            PaymentUrlsRestService.getByAppIdRuntimeAndUpsell(appId, runtime, subsource, licenseId)
                .then((response) => {

                    processPaymentUrlResponse(response);

                })
                .catch((err) => {

                    processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdRuntimeAndUpsell');

                });

        } else if (promotion && !licenseId) {

            PaymentUrlsRestService.getPromotionByAppId(appId, subsource)
                .then((response) => {

                    processPaymentUrlResponse(response);

                })
                .catch((err) => {

                    processPaymentUrlError(err, 'PaymentUrlsRestService.getPromotionByAppId');

                });

        } else if (promotion && licenseId) {

            PaymentUrlsRestService.getPromotionByAppIdAndUpsell(appId, subsource, licenseId)
                .then((response) => {

                    processPaymentUrlResponse(response);

                })
                .catch((err) => {

                    processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdRuntimeAndUpsell');

                });

        } else if (subsource === 'renew') {

            PaymentUrlsRestService.getByAppIdAndLicenseId(appId, subsource, licenseId)
                .then((response) => {

                    processPaymentUrlResponse(response);

                })
                .catch((err) => {

                    processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdAndLicenseId');

                });

        } else {

            PaymentUrlsRestService.getByAppId(appId, subsource)
                .then((response) => {

                    processPaymentUrlResponse(response);

                })
                .catch((err) => {

                    processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppId');

                });

        }

        $scope.closeModal = () => {

            Util.closeModal();

        };

        $scope.onIframeError = (error) => {

            const mixpanelPayload = {
                'Error object data': error,
            };

            Mixpanel.send('ConnectWeb Cart Iframe Error', mixpanelPayload);

            if (!$scope.error) {

                // TODO: Check status code in eventData
                $scope.error = true;
                Util.closeModal();

            }

        };

        $scope.onIframeReady = () => {

            if (!$scope.cartIframeReady) {

                $scope.cartIframeReady = true;
                $scope.showLoading = true;

            }

        };

        $scope.onIframeContentLoaded = () => {

            $scope.checkIframeInterval =
                setInterval($scope.checkIframe, 1000);

        };

        $scope.checkIframe = () => {

            const cartVariant = Cleverbridge.getCurrentScope();

            if (cartVariant) {

                clearInterval($scope.checkIframeInterval);

                let mixpanelCartVersion;
                $scope.cartVariant = cartVariant;
                if ($scope.cartVariant === 'checkout') {

                    mixpanelCartVersion = 'test';
                    angular.element('#lightbox .click-area-lightbox').addClass('payment-card-large-click-area-lightbox');

                }
                if ($scope.cartVariant === 'cart') {

                    mixpanelCartVersion = 'control';

                }

                $scope.showLoading = false;
                $scope.showCartIframe = true;

                mixpanelDetails['A/B Test Payment Cart'] = mixpanelCartVersion;
                Mixpanel.send('ConnectWeb Modal Open', mixpanelDetails);

                $scope.$apply();

            }

        };

        $scope.onPurchaseReady = async (transactionId) => {

            const language = (CWCONFIG.language === 'de') ? 'de' : 'en';
            // link to support page
            $scope.supportUrl = `https://www.avira.com/${language}/support`;
            // reset of the world region
            $scope.paymentSupportUrlRegionCB = `https://shop.avira.com/30/?scope=cuseco&cfg=av092017_ppe&language=${language}`;

            $scope.transactionId = transactionId;

            $scope.showLoading = true;
            $scope.showCartIframe = false;
            $scope.showMergedLicensesSuccess = false;
            angular.element('.payment-cart-modal').css('min-height', '445px');

            $scope.getActivationCodeDetails(transactionId);

            let mergedLicense;
            await LicenseRestService.getAllAsync().then((response) => {

                mergedLicense = response.data.data.find(license => license.id === licenseId);
                LicensesRepository.replace(response.data.data);

            });

            eventManager.broadcast('purchase completed');

            if (appId === 'adwp1' && $rootScope.dwmPurchaseEventSend === false) {

                $rootScope.dwmPurchaseEventSend = true;
                $rootScope.$broadcast('dwm_purchase_completed');

            }

            if ((appId === 'aps10' || appId === 'aps20') && $rootScope.primePurchaseEventSend === false) {

                $rootScope.primePurchaseEventSend = true;
                $rootScope.$broadcast('prime_purchase_completed');

            }

            if (!$scope.showSuccessModal) {

                // check if a merge licenses has been occurred
                // conditions is for the same licenseId:
                // 1. if the app id has changed after purchase then it's true
                // 2. if the the app id has not changed but runtime is extended and was not expired then it's true
                if (onMergingLicense && mergedLicense) {

                    const onMergingLicenseAppId = Util.deepFind(onMergingLicense, 'relationships.app.data.id');
                    const mergedLicenseAppId = Util.deepFind(mergedLicense, 'relationships.app.data.id');
                    const onMergingLicenseExpirationDate = moment(Util.deepFind(onMergingLicense, 'attributes.expiration_date'));
                    const mergedLicenseExpirationDate = moment(Util.deepFind(mergedLicense, 'attributes.expiration_date'));

                    if (onMergingLicenseAppId !== mergedLicenseAppId) {

                        $scope.showMergedLicensesSuccess = true;

                    } else {

                        const hasRuntimeIncreased = onMergingLicenseExpirationDate < mergedLicenseExpirationDate;
                        const checkRuntimeNotExpired = Util.deepFind(onMergingLicense, 'attributes.expired') === false;
                        $scope.showMergedLicensesSuccess = hasRuntimeIncreased && checkRuntimeNotExpired;

                    }

                    $scope.onMergingApp = AppIntegrationsRepository.getById(onMergingLicenseAppId);
                    $scope.extraRuntime = Util.getExtraRuntime(mergedLicense);
                    $scope.showTitleWithTwoProducts = $scope.app.attributes.name !== $scope.onMergingApp.attributes.name;
                    $scope.totalRuntime = Util.getRemainingRuntime(mergedLicense);

                }

                mixpanelDetails['License Merged'] = $scope.showMergedLicensesSuccess;
                mixpanelDetails.Modal = 'Cart Iframe Payment Successful';
                mixpanelDetails['Payment Method'] = 'Card';
                Mixpanel.send('ConnectWeb Modal Open', mixpanelDetails);

                // hide welcome offer banner until next time if user just have succesful made a purchase from banner
                if (subsource === 'banner' || subsource === 'store') {

                    sessionStorage.setItem('hideWOB', true);

                }

                $scope.updateTransactionAndPaymentData();
                $scope.showSuccessModal = true;
                $scope.showLoading = false;
                sessionStorage.setItem('trialModalClosed', 'true');

            }

        };

        $scope.updateTransactionAndPaymentData = async () => {

            // get payment when the purchase is finished
            await PaymentTypesRestService.getAllAsync().then((response) => {

                PaymentTypesRepository.replace(response.data.data);

            });

            // get transactions when the purchase is finished
            await TransactionRestService.getAllAsync().then((response) => {

                TransactionsRepository.replace(response.data.data);

            });
            eventManager.broadcast('purchase completed');

        };

        $scope.getModalWidth = () => {

            const defaultModalWidth = (750 - 2); // 2px for the border;
            const viewPortWidth = window.innerWidth;
            const clickAreaWidth = 32;

            return viewPortWidth > 830 ? defaultModalWidth : viewPortWidth - clickAreaWidth;

        };

        $scope.getActivationCodeDetails = (transactionId) => {


            const activationCodesPromise = ActivationCodeRestService.getAllAsync().then((response) => {

                ActivationCodesRepository.replace(response.data.data);

                // Hide subscriptions widget from homepage
                const hasAPaidLicense = response.data.data.length;
                if (hasAPaidLicense && !$rootScope.cmaGBapplies) {

                    $rootScope.hideHomepageSubscriptionWidget = true;

                } else {

                    $rootScope.hideHomepageSubscriptionWidget = false;

                }
                // End hide subscriptions widget from homepage

            });

            const transactionsPromise = TransactionRestService.getAllAsync().then((response) => {

                TransactionsRepository.replace(response.data.data);

            });

            const promisesArray = [activationCodesPromise, transactionsPromise];

            Promise.allSettled(promisesArray).then(() => {

                const activationCodes = ActivationCodesRepository.getAll();
                const transactions = TransactionsRepository.getAll();

                let currentActivationCode;

                const currentTransaction = transactions.find(transaction => transaction.attributes.payment_transaction_id === transactionId);

                // If the transaction is missing, we are looking for the annual trial
                if (currentTransaction) {

                    currentActivationCode = activationCodes.find(activationCode => activationCode.id === currentTransaction.relationships['activation-code'].data.id);

                } else {

                    currentActivationCode = activationCodes.find(activationCode => activationCode.attributes.subscription_type === 'annual-trial' && activationCode.relationships.app.data.id === 'aps10');
                    $scope.showFreeTrialCmaInfo = true;

                }
                // const currentRuntime = Util.deepFind(currentActivationCode, 'attributes.runtime');
                const currentAppId = Util.deepFind(currentActivationCode, 'attributes.app');

                const subscriptionType = Util.deepFind(currentActivationCode, 'attributes.subscription_type');
                $scope.formattedExpireDate = moment($scope.expireDate).format('L');

                let nextBillingEvent = Util.deepFind(currentActivationCode, 'attributes.next_billing_event');

                if (!nextBillingEvent) {

                    switch (subscriptionType) {

                    case 'yearly':
                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                        break;
                    case 'monthly':
                        nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                        break;
                    case 'annual':
                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                        break;
                    case 'monthly-trial':
                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                        break;
                    case 'annual-trial':
                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                        break;
                    default:
                        nextBillingEvent = expirationDate;

                    }

                }

                $scope.nextBillingEvent = moment(nextBillingEvent).format('L');

                const subscriptionTypeValue = Util.deepFind(currentActivationCode, 'attributes.subscription_type');
                if (subscriptionTypeValue === 'yearly' || subscriptionTypeValue === 'annual' || subscriptionTypeValue === 'annual-trial') {

                    $scope.isAnnual = true;
                    $scope.currentPrice = AppPricesRepository.getSinglePrice(currentAppId, '12', '1');

                } else if (subscriptionTypeValue === 'monthly' || subscriptionTypeValue === 'monthly-trial') {

                    $scope.isMonthly = true;
                    $scope.currentPrice = AppPricesRepository.getSinglePrice(currentAppId, '1', '1');

                }

                const hasPromotion = Util.deepFind($scope.currentPrice, 'attributes.promotion');

                if (hasPromotion) {

                    $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.promotion.pc_price_string');

                } else {

                    $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.price_string');

                }

            });

        };

        const [currentLicense] = LicensesRepository.getAll();
        const modifyDate = new Date(Util.deepFind(currentLicense, 'attributes.modify_date'));
        // The flags are used to prevent multiple calls to the backend
        let checkPaypalPaymentFunctionCall = false;
        let checkPaypalPaymentFunctionApiCalls = true;

        Promise.allSettled = (promises) => {

            const mappedPromises = promises.map(p => p
                .then(value => ({
                    status: 'fulfilled',
                    value,
                }))
                .catch(reason => ({
                    status: 'rejected',
                    reason,
                })));
            return Promise.all(mappedPromises);

        };

        // Check if the last transaction was made using PayPal
        const checkPaypalPayment = () => {

            if (checkPaypalPaymentFunctionCall && checkPaypalPaymentFunctionApiCalls) {

                const activationCodesPromise = ActivationCodeRestService.getAllAsync().then((response) => {

                    ActivationCodesRepository.replace(response.data.data);

                });

                const paymentTypesPromise = PaymentTypesRestService.getAllAsync().then((response) => {

                    PaymentTypesRepository.replace(response.data.data);

                });

                const transactionsPromise = TransactionRestService.getAllAsync().then((response) => {

                    TransactionsRepository.replace(response.data.data);

                });

                const promisesArray = [activationCodesPromise, paymentTypesPromise, transactionsPromise];

                Promise.allSettled(promisesArray).then(() => {

                    checkPaypalPaymentFunctionApiCalls = false;
                    const licenses = LicensesRepository.getAll();
                    const activationCodes = ActivationCodesRepository.getAll();
                    const transactions = TransactionsRepository.getAll();
                    const paymentTypes = PaymentTypesRepository.getAll();

                    if (licenses.length > 0 &&
                        activationCodes.length > 0 &&
                        transactions.length > 0 &&
                        paymentTypes.length > 0) {

                        const [lastLicense] = licenses;
                        const newLicenseModifyDate = new Date(Util.deepFind(lastLicense, 'attributes.modify_date'));
                        const [transaction] = transactions;
                        const transactionId = Util.deepFind(transaction, 'attributes.payment_transaction_id');
                        const associatedPayment = paymentTypes.find(paymentType => paymentType.id === transactionId);
                        const associatedPaymentType = associatedPayment && associatedPayment.attributes.payment_type
                            ? associatedPayment.attributes.payment_type.toLowerCase()
                            : '';

                        if (modifyDate.getTime() !== newLicenseModifyDate.getTime() &&
                            associatedPaymentType.indexOf('paypal') > -1) {

                            angular.element('.payment-cart-modal').css('min-height', '445px');
                            $scope.showLoading = false;
                            $scope.showCartIframe = false;
                            $scope.showSuccessModal = true;
                            $scope.transactionId = transactionId;
                            $scope.$apply();

                            mixpanelDetails.Modal = 'Cart Iframe Payment Successful';
                            mixpanelDetails['Payment Method'] = 'PayPal';
                            Mixpanel.send('ConnectWeb Modal Open', mixpanelDetails);

                        }

                    }

                });

            } else {

                checkPaypalPaymentFunctionCall = true;

            }

        };

        const licensesRepository = LicensesRepository.getObservable();
        const licensesRepositorySubscriber = licensesRepository
            .subscribe(
                () => checkPaypalPayment(),
                () => { },
                () => { },
            );

        $scope.$on('$destroy', () => {

            licensesRepositorySubscriber.dispose();

        });

        $scope.actionDone = () => {

            if ($scope.app.id === 'adwp1') {

                if (($state.current.name.indexOf('.store') > -1) ||
                    ($state.current.name.indexOf('.ltb.buy') > -1)
                ) {

                    $state.go('root.dashboard.dwm', {
                        tab: 'dwm',
                    });

                } else {

                    $scope.closeModal();

                }

            } else {

                $state.go('root.dashboard.subscriptions', {
                    tab: 'plans',
                });

            }

        };

    },
);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/payment-cart/payment-cart.js